<template>
    <div class="page">
        <div class="step">
            <div class="step-items">
                <div class="step-items1">1</div>
                <div class="step-items1-name">购买套餐</div>
            </div>
            <div class="step-items">
                <div class="step-items1">2</div>
                <div class="step-items1-name">实名激活</div>
            </div>
        </div>
        <div class="card-icon">
            <img src="@/assets/new/newCopy/icon05.png" alt="">
        </div>
        <div class="card-msg">根据相关法律法规需要进行实名认证实名认证成功后即可使用本流量卡</div>
        <div class="card-msg-small">填写并提交实名认证后，因运营商需要人工审核，请耐心等待10-20分钟，在此期间无需重复提交</div>
        <div class="card-msg-small">再次打开查询充值链接，即可查询最新实名状态</div>
        <van-button type="primary" block round color="#397EF5" @click="realNameRegister">去实名认证</van-button>
    </div>
</template>
 
<script>
import { Toast,Dialog } from 'vant';
import { wxRequest } from "@/api/user.js";
export default{
    data(){
        return{
        }
    },
    methods:{
          // 实名判断及移动联通卡判断
    realNameRegister() {
      const iccid = localStorage.getItem('iccid')
      wxRequest('sim/is/have/pkgs', { iccid: iccid }, 'get').then((res) => {
        const types = res.data.data
        if (res.data.code === '200') {
          wxRequest('wxAuth/supplierAuth', { iccid: iccid }, 'post').then(
            (res) => {
              if (res.data.code !== '200') {
                if (types === 49) {
                  this.$router.push({
                    path: '/user/cuccToAuth',
                    query: {
                      state: this.state
                    }
                  })
                } else {
                  if (types === 49) {
                    this.$router.push({
                      path: '/user/cuccToAuth',
                      query: {
                        state: this.state,
                        supplierTypeCode: 49
                      }
                    })
                  } else if (types === 3) {
                    // 移动
                    const data = {
                      iccid: localStorage.getItem('iccid')
                    }
                    wxRequest('sim/get/cmcc/auth', data, 'get').then(
                      (res) => {
                        if (res.data.code === '200') {
                          window.location.href = res.data.data
                        } else {
                          Dialog.alert({
                            title: '提示',
                            message: res.data.message
                          })
                        }
                      }
                    )
                  } else {
                    window.location.href =
                            'http://iotapp.iot.189.cn:9090/uapp/certifhtml/certif_entry.html?userCode=r/s9Tc00hjiKcR13MIjZHg==&passWord=9u8VuY1xbez6r6k/BBnLlw==&tmstemp=1581922935504'
                  }
                }
              } else {
                Dialog.alert({
                  title: '实名提示',
                  message: '已实名'
                })
              }
            }
          )
        } else {
          this.reacheShow = true
        }
      })
    },

    }
}
</script>
<style lang="less" scoped>
.page{
    padding-top:30px;
    background: #fff;
    .step{
        width:70%;
        margin:0 auto;
        display: flex;
        position: relative;
        justify-content:space-between;
        &::after{
            display: block;
            content: '';
            height:1px;
            width:80%;
            border-top:1px dashed #979797;
            position: absolute;
            top:16px;
            left:34px;
            z-index: 0;
        }
        .step-items{
            position: relative;
            z-index: 1;
        }
        .step-items1{
            width: 33px;
            height: 33px;
            border-radius:100%;
            text-align: center;
            line-height:33px;
            color: #fff;
            margin:0 auto;
            background: #397EF5;
        }
        .step-items1-name{
            height: 21px;
            font-size: 15px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #000000;
            line-height: 21px;
            margin-top:10px;
        }
    }
    .card-icon{
        width:136px;
        height: 112px;
        margin:38px auto 16px;
        img{
            width:100%;
            height:100%;
        }
    }
    .card-msg{
        width:80%;
        margin: 0 auto 56px;
        text-align: center;
        height: 25px;
        font-size: 18px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #28292D;
        line-height: 25px;
    }
    .card-msg-small{
        background: #F4F6FA;
        width:88%;
        padding: 11px;
        color: #999;
        font-size: 14px;
        line-height: 22px;
        margin:0 auto 11px;
    }
    .van-button{
        width:90%;
        margin:158px auto 0;
    }
}
</style>